import React from "react";
import { Link, NavLink } from "react-router-dom";
import { iCategorie } from "../Core/interface";

import { useGql } from "../Core/gqlHooks";
import { queryHomePage } from "../Core/services";
import { usePageSeo } from "../Core/utils";

import "./Home.scss";

const Home = () => {
  const { data, loading } = useGql({
    query: queryHomePage,
  });

  const page = data?.pageHome?.data?.attributes;
  const categories = data?.categories?.data;

  usePageSeo({
    title: page?.pageTitle,
    keywords: page?.keywords,
    description: page?.metaDescription,
  });

  return (
    <div className="home-container">
      {!loading && (
        <div className="main-container _full-height">
          <nav className="home-nav _full-height">
            <ul className="home-nav-list">
              {categories?.map((categorie: iCategorie) => (
                <li className="item" key={categorie.attributes.name}>
                  <Link
                    className="link"
                    to={`/services/${categorie.attributes.slug}`}
                    title={categorie.attributes.name}
                  >
                    <span className="title">{categorie.attributes.name}</span>
                    <span className="short-desc">
                      {categorie.attributes.description}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
            <NavLink
              to="/contact"
              className="btn -pink"
              title="Info / Rendez-vous"
            >
              Info / Rendez-vous
            </NavLink>
          </nav>
        </div>
      )}
    </div>
  );
};

export default Home;
